import AOS from "aos";
import "aos/dist/aos.css";
import { Bot, Code, Figma, MonitorCog, Smartphone } from 'lucide-react';
import { useEffect } from 'react';

const Feature = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            offset: 100,
        });
    }, []);

    const features = [
        {
            id: 1,
            icon: Code,
            title: "Custom Software Development ",
            description: "Build reliable, scalable, and secure software tailored to your unique business needs",
            bgImage: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"

        },
        {
            id: 2,
            icon: Smartphone,
            title: "Web & Mobile Application Development ",
            description: "From concept to launch, we create responsive web and mobile applications with seamless user experiences",
            bgImage: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
        },
        {
            id: 3,
            icon: Figma,
            title: "UI/UX Strategy & Design ",
            description: "Designs that not only look stunning but also solve real user problems with clarity and creativity",
            bgImage: "https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?ixlib=rb-4.0.3&auto=format&fit=crop&w=2074&q=80"
        },
        {
            id: 4,
            icon: Bot,
            title: "AI & Process Automation ",
            description: "Harness artificial intelligence to automate workflows, reduce costs, and boost efficiency",
            bgImage: "https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
        },
        {
            id: 5,
            icon: MonitorCog,
            title: "IT Consultancy & Support ",
            description: "End-to-end IT advisory, system integration, and technical support to ensure your business never stops",
            bgImage: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
        },
        // {
        //     id: 6,
        //     icon: Zap,
        //     title: "Performance Optimization",
        //     description: "We optimize your systems for maximum efficiency and lightning-fast performance across all platforms.",
        //     bgImage: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
        // }
    ];

    return (
        <div className="min-h-screen bg-[#FFFFFF] py-20 px-4">
            <div className="containers mx-auto px-4">
                {/* Section Header */}
                <div className="text-center mb-16" data-aos="fade-up">
                    <h2 className="text-4xl  md:text-5xl font-bold text-gray-900 mb-6">
                        Our <span className="text-transparent bg-clip-text bg-[#1C74BB]">Premium</span> Services
                    </h2>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                        At Dynamic Softlink, we deliver tailor-made IT solutions and digital services that empower businesses to grow faster, smarter, and more securely. Our focus is on combining innovation with functionality to ensure your business is equipped with the technology it needs to succeed in today’s competitive landscape. Whether you are a startup looking for your first product or an enterprise aiming to scale operations, we have the expertise to support your journey
                    </p>
                </div>

                {/* Features Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {features.map((feature, index) => {
                        const IconComponent = feature.icon;
                        return (
                            <div
                                key={feature.id}
                                className="group relative overflow-hidden rounded-2xl bg-white shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:scale-105 cursor-pointer"
                                data-aos="fade-up"
                                data-aos-delay={index * 100}
                            >
                                {/* Background Image */}
                                <div
                                    className="absolute inset-0 bg-cover bg-center opacity-0 group-hover:opacity-20 transition-opacity duration-700 z-0"
                                    style={{ backgroundImage: `url(${feature.bgImage})` }}
                                ></div>

                                {/* Dark Overlay */}
                                <div className="absolute inset-0 bg-gradient-to-br from-blue-900/0 via-purple-900/0 to-indigo-900/0 group-hover:from-[#e8f1f881] group-hover:via-[#d2e3f294] group-hover:to-[#bbd6ebb7] transition-all duration-700 z-10"></div>

                                {/* Content */}
                                <div className="relative z-20 p-8 h-full flex flex-col">
                                    {/* Icon */}
                                    <div className="mb-6 relative">
                                        <div className="w-16 h-16 bg-gradient-to-br bg-custom-gradient rounded-xl flex items-center justify-center group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 shadow-lg group-hover:shadow-xl">
                                            <IconComponent className="w-8 h-8 text-white" />
                                        </div>
                                        <div className="absolute -top-1 -right-1 w-3 h-3 bg-yellow-400 rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-ping"></div>
                                        <div className="absolute -bottom-1 -left-1 w-2 h-2 bg-pink-400 rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-pulse delay-200"></div>
                                    </div>

                                    {/* Title */}
                                    <h4 className="text-xl font-bold text-gray-900 group-hover:text-black mb-4 transition-colors duration-500">
                                        {feature.title}
                                    </h4>

                                    {/* Description */}
                                    <p className="text-gray-600 group-hover:text-black leading-relaxed flex-grow transition-colors duration-500">
                                        {feature.description}
                                    </p>


                                    {/* <div className="mt-6 opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0 transition-all duration-500 delay-200">
                                        <a href="#" className="inline-flex items-center text-white font-semibold hover:text-yellow-300 transition-colors duration-300">
                                            Learn More 
                                            <svg className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                            </svg>
                                        </a>
                                    </div> */}
                                </div>

                                {/* Corner Accent */}
                                <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-bl from-blue-500/20 to-transparent rounded-bl-full transform scale-0 group-hover:scale-100 transition-transform duration-500 delay-300"></div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Feature;
